import { cssVars } from '@/app/styles';
import { Charts } from '@/chart/chart';
import { LineChartOptions } from '@/chart/chart-options';
import { DisplayMinMaxValuePlugin } from '@/chart/plugins/display-min-max-value-plugin';
import { datasetTypes } from '@/constants';
import {
  SingleValueDataBuilder,
  constructDatasets,
} from '@/utils/chart-data-builder';
import { numberWithCommas } from '@/utils/string-utils';

/**
 * Data builder class responsible for using parent class to build data and seed
 * dataset configurations for this particular chart.
 * ie: dataset color, width, point radius etc.
 *
 * @class CurrentStrPropertiesDataBuilder
 * @extends {SingleValueDataBuilder}
 */
export class CurrentStrPropertiesDataBuilder extends SingleValueDataBuilder {
  constructor(data, chartMode = null, dataType = 'currentStrProperties') {
    super(data, dataType);
    this.datasets = [];
    this.chartMode = chartMode;
    this.datasetConfigurations = CurrentStrPropertiesDataBuilder.configurations;
  }

  static get configurations() {
    return [
      {
        fill: false,
        borderColor: cssVars.chartColors.currentStrPropertiesAccent,
        backgroundColor: cssVars.chartColors.currentStrPropertiesAccent,
        pointBackgroundColor: cssVars.chartColors.currentStrPropertiesAccent,
        pointRadius: 2,
        pointHoverRadius: 4,
        borderWidth: 2,
      },
    ];
  }

  get retrieveDatasets() {
    return constructDatasets(
      this.labels,
      this.data,
      'line',
      this.datasetConfigurations
    );
  }
}

/**
 * Child class of Charts. Here tooltip, plugin, and other props are collected
 * and passed appropriatley to either parent class or chart options class.
 *
 * @class CurrentStrPropertiesChart
 * @extends {Charts}
 */
class CurrentStrPropertiesChart extends Charts {
  static pluginParams = {
    pluginTextColor: cssVars.chartColors.currentStrPropertiesAccent,
    pluginFormatter: numberWithCommas,
    pluginAlignment: 'top',
  };

  static tooltipParams = {
    unit: '',
  };

  static getParams() {
    return {
      pluginParams: this.pluginParams,
      tooltipParams: this.tooltipParams,
    };
  }

  static getOptions(props) {
    return {
      ...CurrentStrPropertiesChart.getParams(),
      ...props,
    };
  }

  constructor(props) {
    super({
      // Class object that knows how to build this chart data
      DataBuilder: CurrentStrPropertiesDataBuilder,
      chartProps: props, // Props passed from the component
      name: datasetTypes.CURRENT_STR_PROPERTIES, // Chart Name
      // Chart Options, note: some come from component props
      options: new LineChartOptions(CurrentStrPropertiesChart.getOptions(props))
        .chartOptions,
      baseType: 'line', // Base type of the chart
      // register plugins for this chart. Note: consider making this global
      plugins: [DisplayMinMaxValuePlugin()],
    });
  }
}

const chart = (props) => new CurrentStrPropertiesChart(props).chart;

// Here we are exporting the connected chart component
export default chart;
